<template>
  <div class="flex flex-row justify-center">
    <div class="w-full max-w-lg">
      <div class="sm:hidden">
        <label for="tabs" class="sr-only">Select a tab</label>
        <!-- Use an "onChange" listener to redirect the user to the selected tab URL. -->
        <select
          id="tabs"
          name="tabs"
          class="
            block
            w-full
            focus:ring-lime-500 focus:border-lime-500
            border-gray-300
            rounded-md
          "
        >
          <option
            v-for="tab in option_tabs"
            :key="tab.name"
            :selected="tab.current"
          >
            {{ tab.name }}
          </option>
        </select>
      </div>
      <div class="hidden sm:block">
        <nav
          class="relative z-0 rounded-lg shadow flex divide-x divide-gray-200"
          aria-label="Tabs"
        >
          <a
            v-for="(tab, tabIdx) in option_tabs"
            :key="tab.name"
            href="#"
            @click.prevent="switchTab(tabIdx)"
            :class="[
              tab.current
                ? 'text-gray-900'
                : 'text-gray-500 hover:text-gray-700',
              tabIdx === 0 ? 'rounded-l-lg' : '',
              tabIdx === option_tabs.length - 1 ? 'rounded-r-lg' : '',
              'group relative min-w-0 flex-1 overflow-hidden bg-white py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 focus:z-10',
            ]"
            :aria-current="tab.current ? 'page' : undefined"
          >
            <i :class="tab.icon"></i>
            <span class="space-icon"></span>
            <span>{{ tab.name }}</span>
            <span
              aria-hidden="true"
              :class="[
                tab.current ? 'bg-lime-500' : 'bg-transparent',
                'absolute inset-x-0 bottom-0 h-0.5',
              ]"
            />
          </a>
        </nav>
      </div>
    </div>
  </div>

  <div class="mt-6" v-show="this.option_tabs[0].current">
    <div class="sm:flex sm:items-center">
      <div class="sm:flex-auto">
        <h1 class="text-xl font-semibold text-gray-900">Cosechas</h1>
      </div>
    </div>
    <div class="flex flex-row justify-end">
      <button
        type="button"
        @click.prevent="download_rep_xlsx"
        class="btn-white"
      >
        <i class="fa-solid fa-file-excel"></i
        ><span class="space-icon"></span>Generar reporte de producción
      </button>
    </div>
    <div class="mt-8 flex flex-col">
      <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
          <div
            class="
              overflow-hidden
              shadow
              ring-1 ring-black ring-opacity-5
              md:rounded-lg
            "
          >
            <table class="table">
              <thead class="table-header">
                <tr>
                  <th scope="col" class="table-header-cell">#</th>
                  <th scope="col" class="table-header-cell">Fecha</th>
                  <th scope="col" class="table-header-cell">Cultivo</th>
                  <th scope="col" class="table-header-cell">Comprador</th>
                  <th scope="col" class="table-header-cell">Cosechado</th>
                  <th scope="col" class="table-header-cell">Descarte</th>
                  <th scope="col" class="table-header-cell">Procesado</th>
                  <th scope="col" class="table-header-cell"></th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr
                  class="table-row"
                  v-for="(harvested_batch, index_batch) in harvested_batches"
                  :key="harvested_batch.id"
                >
                  <td class="table-cell-pos">{{ index_batch + 1 }}</td>
                  <td class="table-cell">
                    {{ dateFormatter(harvested_batch.registered_at) }}
                  </td>
                  <td class="table-cell">{{ harvested_batch.crop.name }}</td>
                  <td class="table-cell">{{ harvested_batch.buyer_name }}</td>
                  <td class="table-cell">
                    {{ numberWithPrecision(harvested_batch.total_weight, 1) }}
                    kg
                  </td>
                  <td class="table-cell">
                    {{
                      numberWithPrecision(harvested_batch.discarded_weight, 1)
                    }}
                    kg
                  </td>
                  <td class="table-cell">
                    {{ numberWithPrecision(harvested_batch.ok_weight, 1) }} kg
                  </td>
                  <td class="table-cell-action">
                    <basic-production-details
                      :harvested_batch="harvested_batch"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="mt-6" v-show="this.option_tabs[1].current">
    <div class="sm:flex sm:items-center">
      <div class="sm:flex-auto">
        <h1 class="text-xl font-semibold text-gray-900">
          Gráfico de rendimiento
        </h1>
      </div>
    </div>
    <div class="mt-8">
      <div class="panel">
        <div class="panel-body">
          <basic-production-graphic
            v-if="graphic_data_loaded"
            :series_data_prop="graphic_series_data"
            :x_categories_prop="graphic_x_categories"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BasicProductionRequester from "@/views/open_queries/requesters/producer/basic_production.js";
import BasicProductionDetails from "@/components/views/open_queries/producer/BasicProductionDetails.vue";
import BasicProductionGraphic from "@/components/views/open_queries/producer/BasicProductionGraphic.vue";

export default {
  name: "OQProducerBasicProduction",
  components: {
    "basic-production-details": BasicProductionDetails,
    "basic-production-graphic": BasicProductionGraphic,
  },
  props: ["producer_id", "crop_id"],
  data() {
    return {
      harvested_batches: [],
      graphic_series_data: [],
      graphic_x_categories: [],
      graphic_data_loaded: false,
      option_tabs: [
        { name: "Cosechas", icon: "fa-solid fa-seedling", current: true },
        {
          name: "Gráfico de rendimiento",
          icon: "fa-solid fa-chart-line",
          current: false,
        },
      ],
    };
  },
  methods: {
    switchTab: function (tabIdx) {
      for (let i = 0; i < this.option_tabs.length; i++) {
        this.option_tabs[i].current = false;
      }
      this.option_tabs[tabIdx].current = true;
    },
    fetchHarvestedBatches: async function () {
      let response = await BasicProductionRequester.listProduction(
        this.producer_id,
        this.crop_id
      );
      this.harvested_batches = response.data.harvests;

      let data_ok_weight = [];
      let data_discarded_weight = [];
      let data_x_categories = [];

      let process_weights = response.data.process_weights;

      console.log(response.data.process_weights);

      for (let i = 0; i < process_weights.length; i++) {
        data_ok_weight.push(process_weights[i].ok_weight);
        data_discarded_weight.push(process_weights[i].discarded_weight);
        data_x_categories.push(process_weights[i].period);
      }

      //neto procesado
      this.graphic_series_data[0] = {
        name: "Peso neto procesado",
        type: "column",
        data: data_ok_weight,
      };

      //descarte
      this.graphic_series_data[1] = {
        name: "Descarte",
        type: "line",
        data: data_discarded_weight,
      };

      this.graphic_x_categories = data_x_categories;

      this.graphic_data_loaded = true;
    },
    download_rep_xlsx: async function () {
      try {
        let response = await BasicProductionRequester.downloadRepXlsx(
          this.producer_id,
          this.crop_id
        );

        const file = response.data;
        var fileURL = window.URL.createObjectURL(new Blob([file]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", "reporte_produccion.xlsx");
        document.body.appendChild(fileLink);

        fileLink.click();
      } catch (error) {
        error;
      }
    },
  },
  beforeMount() {
    this.checkIfAuthenticated();
    this.fetchHarvestedBatches();
  },
};
</script>